'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Loading": "Polaris-Frame-Loading",
  "Level": "Polaris-Frame-Loading__Level"
};

exports.default = styles;
